export default __webpack_public_path__ + "media/74e5c77a438a9f80cbb82519ce8e2cedbfb7c331570753f1273f1cfff25d197b.svg";